import React from 'react';
import '../css/DesktopAgentInstallModal.css';

interface DesktopAgentInstallModalProps {
  onClose: () => void;
}

export default function DesktopAgentInstallModal({ onClose }: DesktopAgentInstallModalProps) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>🐧 Desktop Sync Installation (Linux)</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        
        <div className="modal-body">
          <p>Your installer has been downloaded. Follow these steps to install:</p>
          
          <div className="install-steps">
            <div className="step">
              <h3>Step 1: Make the script executable</h3>
              <code className="command-box">
                chmod +x ~/Downloads/LinuxDesktopSync.deb
              </code>
            </div>
            
            <div className="step">
              <h3>Step 2: Run the installer</h3>
              <code className="command-box">
                ~/Downloads/LinuxDesktopSync.deb
              </code>
            </div>
            
            <div className="step">
              <h3>Step 3: Start the Desktop Sync agent</h3>
              <code className="command-box">
                desktop-sync start
              </code>
            </div>
          </div>
          
          <p className="note">
            <strong>Note:</strong> The agent will automatically sync your desktop files in the background.
          </p>
        </div>
        
        <div className="modal-footer">
          <button className="btn-primary" onClick={onClose}>Got it!</button>
        </div>
      </div>
    </div>
  );
}